import React from 'react';
import logo from './images/logowhite.png';

function Header({ onBack }) {
  return (
    <div style={{ position: 'relative', width: '100%', marginBottom: 5 }}>
      {onBack && (
        <button
          type="button"
          className="header-back"
          onClick={onBack}
          aria-label="Back"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            background: 'none',
            border: 'none',
            color: '#282c34',
            cursor: 'pointer',
            padding: 0,
            zIndex: 2,
            display: 'flex',
            alignItems: 'center'
          }}
        >
          <svg width="28" height="28" viewBox="0 0 20 20" fill="none">
            <path d="M13 16L7 10L13 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      )}
      <img
        src={logo}
        alt="Logo"
        style={{
          display: "block",
          margin: "0 auto",
          height: "84px", // Increased from 48px to 64px
          width: "auto"
        }}
      />
    </div>
  );
}

export default Header;